import { LIST_GC_TIME_MS, LIST_STALE_TIME_MS, useApiClient } from '@klareospace/pharos-lib-front-utils';
import type { Task } from '@klareospace/pharos-lib-types';
import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { createOrdersApi, orderKeys } from '../api';

// ─── Types ────────────────────────────────────────────────────────────────────

interface UseOrderTasksOptions {
  enabled?: boolean;
}

// ─── Hook ─────────────────────────────────────────────────────────────────────

export function useOrderTasks(orderId: string, options: UseOrderTasksOptions = {}): UseQueryResult<Task[]> {
  const { enabled = true } = options;
  const client = useApiClient('deliveries');
  const api = createOrdersApi(client);

  return useQuery({
    enabled: enabled && orderId.length > 0,
    gcTime: LIST_GC_TIME_MS,
    queryFn: () => api.getOrderTasks(orderId),
    queryKey: orderKeys.tasks(orderId),
    staleTime: LIST_STALE_TIME_MS,
  });
}
